import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { logger } from '@fiverr-private/obs';
import { Select, Option } from '@fiverr-private/fit';
import { getContext, I18nProvider } from '@fiverr-private/fiverr_context';
import { REVIEWS_HEADER, TEXT } from '../../../constants';
import { reportEvent, Events } from '../../../utils/reports/sort';
import withImpressions from '../hoc/withImpressions';

import './index.styles.scss';

const IMPRESSION_COMPONENT_CLASS = 'filter-reviews';

const impressionConfig = {
    DOMSelector: `.${IMPRESSION_COMPONENT_CLASS}`,
    getImpressionData: (data, { type }) => ({
        type: 'reviews_breakdown_sort_by_is_shown',
        page: {
            element: {
                name: 'sort_by',
                type: TEXT,
                text: type,
            },
            component: {
                name: REVIEWS_HEADER,
            },
        },
    }),
};

const FilterReviews = ({ className, fetchReviews, type, onFilterChange, filterValues }) => {
    const handleFetchReviews = (e) => {
        const filterType = e.target.value;
        fetchReviews({
            filterType,
            isFilter: true,
        })
            .then((eventData) => {
                eventData && reportEvent(Events.changeFilter, eventData);
                onFilterChange && onFilterChange(filterType);
            })
            .catch((error) => {
                logger.error(error, {
                    func: 'fetchReviews',
                    component: 'FilterReviews',
                });
            });
    };

    const { isTouch } = getContext();

    return (
        <I18nProvider>
            {({ i18n }) => (
                <div className={classnames(IMPRESSION_COMPONENT_CLASS, className)}>
                    {!isTouch && (
                        <h6 className="filter-dropdown-text tbody-5">{i18n.t('reviews.breakdown.sort_by')}</h6>
                    )}
                    <Select
                        onChange={handleFetchReviews}
                        value={type}
                        className="filter-reviews-select"
                        contentClassName="filter-reviews-select-content tbody-5"
                        containerFullWidth
                    >
                        {filterValues.map((filter) => (
                            <Option key={filter} value={filter}>
                                {i18n.t(`reviews.gigs._inner_gig.drop_${filter}`)}
                            </Option>
                        ))}
                    </Select>
                </div>
            )}
        </I18nProvider>
    );
};

FilterReviews.propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    filterValues: PropTypes.arrayOf(PropTypes.string),
    fetchReviews: PropTypes.func,
    onFilterChange: PropTypes.func,
};

FilterReviews.defaultProps = {
    filterValues: [],
    fetchReviews: () => [],
    onFilterChange: () => null,
};

export default withImpressions(FilterReviews, impressionConfig);
